module.exports = __webpack_public_path__ + "media/images/logo-20minutesfr-6cfa4f73eaba3951510d5e7db0a82b92.png";